import axios from '../../axios';
import { useMutation } from '@tanstack/react-query';
import type { TError } from '@onesource/schemas';
import { ENTITY } from '../entity';

export const useSpaceCheckinMutation = () => {
  return useMutation<{ createdAt: string } | null, TError, string>({
    mutationKey: [ENTITY, 'spaces', 'checkin'],
    mutationFn: async (spaceId: string) => {
      const res = await axios.post<{ createdAt: string } | null>(`/community-hub/spaces/${spaceId}/checkin`);
      return res.data;
    },
  });
};
